import { POST } from '../_http';
import type { operations } from '@/types/schemas/calcs.main';
type controller = operations['TotalScheduledEquityReleaseController_calculate'];

export type TotalScheduledEquityReleaseBody = controller['requestBody']['content']['application/json'];
export type TotalScheduledEquityReleaseResponse = controller['responses']['200']['content']['application/json'];

export const totalScheduledEquityRelease = POST('/formulas/total-scheduled-equity-release')<
  TotalScheduledEquityReleaseBody,
  TotalScheduledEquityReleaseResponse
>;
